import { useState } from "react"
import axiosInstance from "../../../services/axios-client"
import { toast } from "react-toastify"

const useFaq = () => {
    const [payload, setPayload] = useState()
    const getActiveHomepage = async() => {
        try {
            let res = await axiosInstance.get(`/auth/faqs/active`)
                if (res.status===200) {
                    let allData = []
                    for (let index = 0; index < res.data.data.length; index++) {
                        let { englishTitle, indonesianTitle } = extractContent(res.data.data[index].Title)
                        let { englishTitle: englishAnswer, indonesianTitle:indonesianAnswer } = extractContent(res.data.data[index].Answer)
                        allData.push({
                            key: index,
                            label: (
                                <div>
                                    <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0 }}>{indonesianTitle}</pre>
                                    <i><pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0 }}>{englishTitle}</pre></i>
                                </div>
                            ),
                            children:  (
                                <div>
                                    <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0 }}>{indonesianAnswer}</pre>
                                    <br/>
                                    <br/>
                                    <i><pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0 }}>{englishAnswer}</pre></i>
                                </div>
                            )
                        })
                        
                    }
                    setPayload(allData)
                }
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        }
    }

    const extractContent = (text) => {
        const englishMatch = text.match(/\[ENG\](.*?)\[IND\]/s);
        const indonesianMatch = text.match(/\[IND\](.*)/s);

        // console.log("match", englishMatch, indonesianMatch)

        return {
            englishTitle: englishMatch ? englishMatch[1].trim() : "",
            indonesianTitle: indonesianMatch ? indonesianMatch[1].trim() : ""
        };
    };

    return{
        payload,
        getActiveHomepage,
    }
}

export default useFaq